export default {

	selectors: {
		filter: '.js-filter',
	},

	init() {
		Array.from(document.querySelectorAll(this.selectors.filter)).forEach((filter) => {
			filter.addEventListener('click', (event) => {
				event.preventDefault();
				this.filter(event);
			});
		});
	},

	filter(event) {
		const { option, value } = event.currentTarget.dataset;
		this.updateQuery(option, value);
	},

	updateQuery(option, value) {
		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.search);
		if (value.length > 0) {
			params.set(option, value);
		} else {
			params.delete(option);
		}
		url.search = params.toString();
		window.location.assign(url);
	},

};
